import React, {Component} from 'react'
import Modal from 'react-modal'

class SavingModal extends Component {
    constructor(props){
        super(props)

        this.dismissSaving = this.dismissSaving.bind(this)
    }

    dismissSaving(){
        const { setIsOpenSavingModal } = this.props
        setIsOpenSavingModal(false)
    }

    render(){
        const { isOpenSavingModal } = this.props
        return  <Modal  isOpen={isOpenSavingModal}
                    onRequestClose={this.dismissSaving} 
                    className="modal is-active"
                    overlayClassName="modal-overlay"
                    htmlOpenClassName="ReactModal__Html--open" >
                    <div className="modal-background"></div>
                    <div className="modal-content modal-alert">
                        <div className="UploadProgressContentBox box">
                            <div className="content"></div>
                            <h4 className="UploadProgressHeading title is-size-4 is-size-5-mobile has-text-white">กำลังบันทึกข้อมูล</h4>
                            <br/>
                            <span className="MapsDetailsLoadingIcon icon is-medium">
                                <i className="fas fa-spinner fa-pulse fa-2x"></i>
                            </span>
                    </div>
                    </div>
                </Modal>
    }
}

export default SavingModal


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsSavingModal.js